import {
  Button,
  Layout,
  theme,
  Form,
  Checkbox,
  notification,
  Select,
  Row,
  Col,
  Input,
} from "antd";
import { useEffect, useCallback, useState } from "react";
import "../CreateRole/CreateRole.css";

import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import RoleApi from "../../common/Apis/RoleApi";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import ComponentsApi from "../../common/Apis/ComponentsApi";
import ActionsApi from "../../common/Apis/ActionsApi";
import RuntimeConfigsApi from "../../common/Apis/RuntimeConfigsApi";

const CreateRole = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { Content } = Layout;

  const [UserRole, setUserRole] = useState("");
  const [Components, setComponents] = useState([]);
  const [Actions, setActions] = useState([]);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const { useToken } = theme;
  const { token } = useToken();
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [ListRoles, setListRoles] = useState([]);
  const [Allpermissions, setAllpermissions] = useState([]);
  const [CreateNew, setCreateNew] = useState(false);

  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [formPaginate] = Form.useForm();
  formPaginate.setFieldsValue({
    paginate: PaginateLimit,
  });
  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({
      paginate: value,
    });
    ComponentsApi.ListComponents(0, value)
      .then((response) => {
        settotalPages(response.totalPages);
        setActions(response.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [currentPage, setCurrentPage] = useState(1);
  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1
    ComponentsApi.ListComponents(pageNew, PaginateLimit)
      .then((response) => {
        setPaginatePage(pageNew)
        settotalPages(response.totalPages);
        setActions(response.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getComponents = useCallback(() => {
    ComponentsApi.ListComponents()
      .then((response) => {
        setComponents(response.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const getActions = useCallback(() => {
    ActionsApi.Listactions()
      .then((response) => {
        setActions(response.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getComponents();
    getActions();
    if (decodedToken?.roles.includes("SUPER_ADMIN")) {
      getRuntimeConfigs()
    }
  }, [getActions, getComponents]);


  const [TENANT_ADMIN_PERMISSION, setTENANT_ADMIN_PERMISSION] = useState(null);

  const getRuntimeConfigs = useCallback(() => {
    RuntimeConfigsApi.ListRuntimeConfigs()
      .then((response) => {
        if ((response?.payloadDto.filter(item => item?.configKey === 'TENANT_ADMIN_PERMISSION_SETTING' && item?.configValue === false && item?.environment === token?.environment).length === 0)) {
          setTENANT_ADMIN_PERMISSION(response?.payloadDto.filter(item => item?.configKey === 'TENANT_ADMIN_PERMISSION_SETTING' && item?.configValue === 'false' && item?.environment === token?.environment)?.[0]);
          form.setFieldsValue({
            roleName: 3,
          });
          setUserRole(3);
          RoleApi.ListRolePermissions(3)
            .then((response) => {
              const permissionDTOs = response?.payload?.permissionDTOs.map(
                (obj) => obj.code
              );
              setPermissions(permissionDTOs);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
      .catch((err) => {
        setTENANT_ADMIN_PERMISSION(null);
        console.log(err);
      });
  }, []);

  const handleSubmit = (data) => {
    if (TENANT_ADMIN_PERMISSION) {
      let formData = JSON.stringify({
        configValue: true,
        configKey: "TENANT_ADMIN_PERMISSION_SETTING",
        tag: TENANT_ADMIN_PERMISSION?.tag,
        id: TENANT_ADMIN_PERMISSION?.id,
        activeFrom: TENANT_ADMIN_PERMISSION?.activeFromN,
        activeTo: TENANT_ADMIN_PERMISSION?.activeToN,
        tenantDTO: {
          id: decodedToken?.tenantId,
          tenantApiKey: decodedToken?.tenantApiKey,
        },
      })

      RuntimeConfigsApi.PutRuntimeConfigs(TENANT_ADMIN_PERMISSION?.id, formData)
        .then((response) => {

        })
        .catch((err) => {

        });
    }
    if (CreateNew === true) {
      let formData = JSON.stringify({
        permissionDTOs: Allpermissions.filter((item) =>
          Permissions.includes(item.code)
        ).map(({ id }) => ({ id })),
        code: data.code,
        name: data.name,
      });
      console.log(formData);
      // Create Role Api
      RoleApi.CreateNewRole(formData)
        .then((response) => {
          console.log(response);
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>
                {response.resultStatus}
              </span>
            ),
            description: "Permission Create Success",
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#b3ffb3",
              color: "green",
            },
          });
          setTimeout(() => {
            window.location.reload();
          }, 500);
        })
        .catch((err) => {
          console.log(err);
          // Error Notification
          if (err.apiError.status) {
            notification.open({
              message: (
                <span style={{ fontWeight: "bold" }}>
                  {err.apiError.status}
                </span>
              ),
              description: err.apiError.message,
              closeIcon: false,
              duration: 3,
              style: {
                backgroundColor: "#fff2f0",
                color: "red",
              },
            });
          }
        });
    } else {
      let formData = JSON.stringify({
        permissionList: Permissions,
        roleDTO: {
          id: UserRole,
        },
      });

      // Create Role Permissions Api
      RoleApi.CreateRolePermissions(formData)
        .then((response) => {
          console.log(response);
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>
                {response.resultStatus}
              </span>
            ),
            description: "Permission Create Success",
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#b3ffb3",
              color: "green",
            },
          });
          // return navigate("/login");
        })
        .catch((err) => {
          console.log(err);
          // Error Notification
          if (err.apiError.status) {
            notification.open({
              message: (
                <span style={{ fontWeight: "bold" }}>
                  {err.apiError.status}
                </span>
              ),
              description: err.apiError.message,
              closeIcon: false,
              duration: 3,
              style: {
                backgroundColor: "#fff2f0",
                color: "red",
              },
            });
          }
        });
    }
  };

  const getRoles = useCallback(() => {
    RoleApi.ListAllRoles()
      .then((response) => {
        setListRoles(response.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const getAllpermissions = useCallback(() => {
    RoleApi.ListAllpermissions()
      .then((response) => {
        console.log(response);
        setAllpermissions(response.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    PageLoading();
    getRoles();
    getAllpermissions();
  }, [getRoles, PageLoading, getAllpermissions]);

  const [Permissions, setPermissions] = useState([]);
  const [componentDTOList, setComponentDTOList] = useState([
    {
      code: "TENANT",
      name: "TENANT",
      actionDTOList: [],
    },
    {
      code: "MERCHANT",
      name: "MERCHANT",
      actionDTOList: [],
    },
  ]);
  const [actionDTOList, setactionDTOList] = useState([
    {
      actionName: "ADD",
    },
    {
      actionName: "VIEW",
    },
    {
      actionName: "EDIT",
    },
    {
      actionName: "DELETE",
    },
    {
      actionName: "VIEW_LIST",
    },
  ]);

  const addIdToObject = (e) => {
    let getActionValue = e.target.value;

    if (Permissions.some((item) => item === getActionValue)) {
      setPermissions((prevSelectedItems) =>
        prevSelectedItems.filter((item) => item !== getActionValue)
      );
    } else {
      setPermissions((prevSelectedItems) => [
        ...prevSelectedItems,
        getActionValue,
      ]);
    }
  };

  const isCheckboxChecked = (value) => {
    return Permissions.includes(value);
  };

  const SelectRole = (value) => {
    RoleApi.ListRolePermissions(value)
      .then((response) => {
        const permissionDTOs = response?.payload?.permissionDTOs.map(
          (obj) => obj.code
        );
        setPermissions(permissionDTOs);
      })
      .catch((err) => {
        console.log(err);
      });

    setUserRole(value);
  };
  const handleCreateNew = () => {
    setCreateNew(true);
    setPermissions([]);
  };
  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            form={form}
            name="nest-messages"
            layout="vertical"
            className="userRole FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row
                gutter={16}
                className={`${CreateNew === true ? "" : "d-none"}`}
              >
                <Col span={8}>
                  <Form.Item
                    name="code"
                    label="Code"
                    className="text-lable"
                    rules={[
                      {
                        required: CreateNew == true ? true : false,
                        message: "Please enter Code.",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Code"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="name"
                    label="Name"
                    className="text-lable"
                    rules={[
                      {
                        required: CreateNew == true ? true : false,
                        message: "Please enter Role Name.",
                      },
                      {
                        pattern: /^[A-Za-z\s]+$/,
                        message: "Only alphabet characters are allowed.",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Button
                    style={{ height: "45px", marginTop: "25px" }}
                    className="btn btn-primary btn-back pt-2"
                    onClick={() => setCreateNew(false)}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>{" "}
              <Row
                gutter={16}
                className={`${CreateNew === true ? "d-none" : ""}`}
              >
                <Col span={8}>
                  <Form.Item
                    name="roleName"
                    label="Role Name*"
                    className="text-lable"
                    rules={[
                      {
                        required: CreateNew == true ? false : true,
                        message: "Name must include only alphabet characters.",
                      },
                    ]}
                  >
                    {ListRoles && (
                      <Select
                        className="control-Select"
                        placeholder="Select role name"
                        onChange={SelectRole}
                        options={ListRoles.map((item) => ({
                          value: item?.id,
                          label: item?.name,
                        }))}
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Button
                    style={{ height: "50px", marginTop: "30px" }}
                    className="btn btn-primary btn-save"
                    onClick={handleCreateNew}
                  >
                    Add new
                  </Button>
                </Col>
              </Row>
              <table id="customers" className="mt-4 ">
                <thead>
                  <tr className="table-class">
                    <th></th>
                    {Actions.map((action, index2) => (
                      <th style={{ width: "10%" }} key={index2}>
                        {action.code}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {Components.map((component, index) => (
                    <tr key={index} className="table-class rounded-row">
                      <td className="function">{component.name}</td>
                      {Actions.map((action, index2) => (
                        <td key={index2}>
                          <Checkbox
                            checked={isCheckboxChecked(
                              action.code + "_" + component.code
                            )}
                            value={`${action.code}_${component.code}`}
                            onChange={addIdToObject}
                            disabled={!CreateNew}
                          ></Checkbox>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Save
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default CreateRole;
